import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { composeUrl } from 'app/core/shared/helper/url.helper';
import {
    RemedialProgressResponse,
    OtherActivitiesResponse,
} from '../model/well-integrity-management.type';

@Injectable({
    providedIn: 'root',
})
export class WellIntergrityManagementService {
    constructor(protected _httpClient: HttpClient) { }

    getUnhealthyWells() {
        const url = composeUrl(
            `/v1/WIM/DashboardWim/overall-overview/unhealthy-wells`,
        );
        return this._httpClient.get<any>(url);
    }

    getWellMaintenancePlanVsActual() {
        const url = composeUrl(
            `/v1/WIM/DashboardWim/overall-overview/well-maintenance-plan-vs-actual`,
        );
        return this._httpClient.get<any>(url);
    }

    getRemedialProgress() {
        const url = composeUrl(
            `/v1/WIM/DashboardWim/overall-overview/remedial-progress`,
        );
        return this._httpClient.get<RemedialProgressResponse>(url);
    }

    getOtherActivities() {
        const url = composeUrl(
            `/v1/WIM/DashboardWim/overall-overview/other-activities`,
        );
        return this._httpClient.get<OtherActivitiesResponse>(url);
    }

    getKpiBaselines() {
        const url = composeUrl(`dashboard/kpibaselines`);
        return this._httpClient.get<any[]>(url);
    }

    getDashboardKpiAll() {
        const url = composeUrl(`v1/WIM/DashboardWim/overall-overview/kpi/all`);
        return this._httpClient.get<any>(url);
    }

    saveKpiBaseline(payload: any) {
        const url = composeUrl(`dashboard/kpibaselines`);
        return this._httpClient.post<any>(url, payload);
    }

    getKpiStringSelections(year: number) {
        const url = composeUrl(
            `dashboard/kpibaselines/string-selections?year=${year}`,
        );
        return this._httpClient.get<any>(url);
    }

    bulkUpdateKpiStringSelections(payload: any[]) {
        const url = composeUrl(`dashboard/kpibaselines/bulk-update-selections`);
        // Use post since typical bulk updates that create/modify use post/put.
        // Assuming post is used.
        return this._httpClient.post<any>(url, payload);
    }

    getWipRemark() { // get all wip remark
        const url = composeUrl(`v1/WIM/DashboardWim/WipRemark`);
        return this._httpClient.get<any>(url);
    }

    getWipRemarkbyId(id: string) { // get all wip remark
        const url = composeUrl(`v1/WIM/DashboardWim/WipRemark/${id}`);
        return this._httpClient.get<any>(url);
    }

    getWipRemarkAttchmentById(id: string) { // get all wip remark
        const url = composeUrl(`v1/WellActivityPlanning/wip-remark/attachment/${id}`);
        return this._httpClient
            .get(url, { responseType: 'blob' });
    }

    deleteWipRemarkAttchmentById(id: string) { // get all wip remark
        const url = composeUrl(`v1/WellActivityPlanning/wip-remark/attachment/${id}`);
        return this._httpClient.delete<any>(url);
    }
}
